export const actions = {
  BANNERS_LOAD_REQUESTED: 'BANNERS_LOAD_REQUESTED',
  BANNERS_LOAD_SUCCEEDED: 'BANNERS_LOAD_SUCCEEDED',
  BANNERS_LOAD_FILED: 'BANNERS_LOAD_FILED',

  BANNERS_DIAS_SEMANA_LOAD_REQUESTED: 'BANNERS_DIAS_SEMANA_LOAD_REQUESTED',
  BANNERS_DIAS_SEMANA_LOAD_SUCCEEDED: 'BANNERS_DIAS_SEMANA_LOAD_SUCCEEDED',
  BANNERS_DIAS_SEMANA_LOAD_FILED: 'BANNERS_DIAS_SEMANA_LOAD_FILED',

  BANNER_BYID_LOAD_REQUESTED: 'BANNER_BYID_LOAD_REQUESTED',
  BANNER_BYID_LOAD_SUCCEEDED: 'BANNER_BYID_LOAD_SUCCEEDED',
  BANNER_BYID_LOAD_FILED: 'BANNER_BYID_LOAD_FILED',

  BANNER_BYID_LOAD_INSERT_REQUESTED: 'BANNER_BYID_LOAD_INSERT_REQUESTED',

  BANNER_UPDATE_REQUESTED: 'BANNER_UPDATE_REQUESTED',
  BANNER_UPDATE_SUCCEEDED: 'BANNER_UPDATE_SUCCEEDED',
  BANNER_UPDATE_FILED: 'BANNER_UPDATE_FILED',

  BANNER_ACTIVAR_UPDATE_REQUESTED: 'BANNER_ACTIVAR_UPDATE_REQUESTED',
  BANNER_ACTIVAR_UPDATE_SUCCEEDED: 'BANNER_ACTIVAR_UPDATE_SUCCEEDED',
  BANNER_ACTIVAR_UPDATE_FILED: 'BANNER_ACTIVAR_UPDATE_FILED',

  BANNER_INSERT_REQUESTED: 'BANNER_INSERT_REQUESTED',
  BANNER_INSERT_SUCCEEDED: 'BANNER_INSERT_SUCCEEDED',
  BANNER_INSERT_FILED: 'BANNER_INSERT_FILED',

  BANNER_DELETE_REQUESTED: 'BANNER_DELETE_REQUESTED',
  BANNER_DELETE_SUCCEEDED: 'BANNER_DELETE_SUCCEEDED',
  BANNER_DELETE_FILED: 'BANNER_DELETE_FILED',

  BANNER_SEMANA_UPDATE_REQUESTED: 'BANNER_SEMANA_UPDATE_REQUESTED',
  BANNER_SEMANA_UPDATE_SUCCEEDED: 'BANNER_SEMANA_UPDATE_SUCCEEDED',
  BANNER_SEMANA_UPDATE_FILED: 'BANNER_SEMANA_UPDATE_FILED',

  BANNER_SEMANA_BY_IDIOMA_ID_LOAD_REQUESTED: 'BANNER_SEMANA_BY_IDIOMA_ID_LOAD_REQUESTED',
  BANNER_SEMANA_BY_IDIOMA_ID_LOAD_SUCCEEDED: 'BANNER_SEMANA_BY_IDIOMA_ID_LOAD_SUCCEEDED',
  BANNER_SEMANA_BY_IDIOMA_ID_LOAD_FILED: 'BANNER_SEMANA_BY_IDIOMA_ID_LOAD_FILED',
}

export const getBannersAction = dispatch => {
  dispatch({
    type: actions.BANNERS_LOAD_REQUESTED,
  })
}

export const getBannersDiasSemanaAction = (dispatch, idiomaId) => {
  dispatch({
    type: actions.BANNERS_DIAS_SEMANA_LOAD_REQUESTED,
    payload: idiomaId,
  })
}

export const getBannerSemanaByIdiomaIdAction = (dispatch, idiomaId) => {
  dispatch({
    type: actions.BANNER_SEMANA_BY_IDIOMA_ID_LOAD_REQUESTED,
    payload: idiomaId,
  })
}

export const getBannerCreateEditByIdAction = (dispatch, id) => {
  if (id) {
    dispatch({
      type: actions.BANNER_BYID_LOAD_REQUESTED,
      payload: id,
    })
  } else {
    dispatch({
      type: actions.BANNER_BYID_LOAD_INSERT_REQUESTED,
    })
  }
}

export const onSubmitInsertBannerFormAction = (dispatch, formBanner) => {
  dispatch({
    type: actions.BANNER_INSERT_REQUESTED,
    payload: formBanner,
  })
}

export const onSubmitUpdateBannerFormAction = (dispatch, formBanner) => {
  dispatch({
    type: actions.BANNER_UPDATE_REQUESTED,
    payload: formBanner,
  })
}

export const onSubmitUpdateActivarBannerFormAction = (dispatch, formBanner) => {
  dispatch({
    type: actions.BANNER_ACTIVAR_UPDATE_REQUESTED,
    payload: formBanner,
  })
}

export const deleteBannerAction = (dispatch, id) => {
  dispatch({
    type: actions.BANNER_DELETE_REQUESTED,
    payload: id,
  })
}

export const onChangeMenuSemanaBannerAction = (dispatch, menuSemanaBannerForm) => {
  dispatch({
    type: actions.BANNER_SEMANA_UPDATE_REQUESTED,
    payload: menuSemanaBannerForm,
  })
}
